import React from 'react';
import { FlatList, View, StyleSheet } from 'react-native';
import { IUser } from '../../../../types/user';
import CredentialItem from './CredentialItem';
import { useTenantContext } from '../../../../contexts';
import EmptyCredential from './EmptyCredential';
import CredentialSkeleton from '../../../../components/skeletons/CredentialSkeleton';

interface ICredentialListProps {
  user: IUser;
  credentials: any[];
  setSendUserCredModalOpen: (value: boolean) => void;
}

/**
 * CredentialList component
 *
 * @param {*} { user, credentials, setSendUserCredModalOpen }
 * @return {*}
 */
const CredentialList: React.FC<ICredentialListProps> = ({
  user,
  credentials,
  setSendUserCredModalOpen
}) => {
  const tenantContext = useTenantContext();

  const renderItem = ({ item, index }: { item: any; index: number }) => (
    <CredentialItem credential={item} key={index} />
  );

  const ListFooterComponent = () =>
    tenantContext.isRefreshingCredentials ? <CredentialSkeleton /> : null;

  if (tenantContext.isLoadingCredentials) {
    return (
      <View style={styles.loadingContainer}>
        <CredentialSkeleton />
        <CredentialSkeleton />
        <CredentialSkeleton />
      </View>
    );
  }

  if (credentials.length === 0) {
    return tenantContext.isRefreshingCredentials ? (
      <CredentialSkeleton />
    ) : (
      <EmptyCredential user={user} setSendUserCredModalOpen={setSendUserCredModalOpen} />
    );
  }

  return (
    <View style={styles.container}>
      <FlatList
        data={credentials}
        renderItem={renderItem}
        keyExtractor={(item) => item.credentialExchangeId as string}
        scrollEnabled={false}
        nestedScrollEnabled={true}
        ListFooterComponent={ListFooterComponent}
        ListFooterComponentStyle={styles.listFooter}
        showsVerticalScrollIndicator={false}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1
  },
  loadingContainer: {
    gap: 12
  },
  listFooter: {
    marginTop: 12
  }
});

export default CredentialList;
